import React, { useEffect } from 'react'
import AddMashup from '../components/AddMashup/AddMashup'

function Home(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
      <h1>{props.title}</h1>
    
      <div id="home">
        <h2>Most Recent Video</h2>
        <div className="iframe-container">
          <iframe src="https://www.youtube.com/embed/Y8vfdBoQaIg" title="IVE X Kep1er x LE SSERAFIM x NewJeans - I Am x Giddy x Fearless x Hype Boy Mashup" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="" loading="lazy" frameBorder="0"></iframe>
        </div>
        <h2>Most Recent Mashup</h2>
        <AddMashup link="Y8vfdBoQaIg" title="IVE X Kep1er x LE SSERAFIM x NewJeans - I Am x Giddy x Fearless x Hype Boy Mashup" type="released"/>
        <div class="bottom-space"><br /></div>
      </div>
    </main>
  )
}

export default Home